module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-m",
      "header": false,
      "customClass": 'heightAuto',
      "footer": true
    }
  }, [_c('div', {
    staticClass: "p-4",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('h2', {
    staticClass: "text-center bold mb-3"
  }, [_vm._v("Sales & Commissions Report")]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("Please select one of the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("available")]), _vm._v(" reports:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 my-2"
  }, [(_vm.getYearsAndMonths.length > 0) ? _c('div', {
    staticClass: "col-8 pl-0"
  }, [_c('v-select', {
    attrs: {
      "label": "referenceMonth",
      "placeholder": "Report List",
      "options": _vm.getYearsAndMonths
    },
    model: {
      value: (_vm.selectedData),
      callback: function($$v) {
        _vm.selectedData = $$v
      },
      expression: "selectedData"
    }
  })], 1) : _c('div', {
    staticClass: "w-100 text-center"
  }, [_c('loader')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedData || _vm.getIsDownloadingSupplierReport
    },
    on: {
      "click": _vm.pressDownload
    }
  }, [_vm._v("Download")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb9dd70"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/PrintReport.vue
// module id = 1446
// module chunks = 0